import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {LeadOriginTypesActions} from '../store';
import {LeadOriginTypesSelectors} from '../store/selectors';

@Injectable()
export class LeadOriginTypesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.leadOriginTypesLoaded().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  leadOriginTypesLoaded(): Observable<boolean> {
    return this.store.pipe(
      select(LeadOriginTypesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(LeadOriginTypesActions.LoadLeadOriginTypes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
